// extracted by mini-css-extract-plugin
export default {"root":"Rating_root__H3mpg"};